import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { JuniferService } from "@/services/JuniferService"
import { AccountService } from "@/services/AccountService"
import { IJuniferTicket } from "@/models/juniferTickets/juniferTicket.types"
import {
  preDefaultStepCode,
  defaultStepCode,
  preSatisfiedDefaultClosedStepCode,
  preDefaultClosedStepCode,
  preSatisfiedDefaultStepCode,
} from "@/constants/defaultStepCodes"

export const getDefaultNotice = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const juniferTicketsQuery = JuniferService.getTicketsForAccount(
    coreIdQuery.data,
  )

  queries.add(coreIdQuery)
  queries.add(juniferTicketsQuery)

  const latestDefaultNotice = getLatestDefaultNoticeTicket(
    juniferTicketsQuery.data ?? [],
  )

  return queries.setData(latestDefaultNotice).getAggregate()
}

export const getLatestDefaultNoticeTicket = (
  juniferTickets: IJuniferTicket[],
) => {
  const defaultNoticeTickets: IJuniferTicket[] = juniferTickets.filter(
    (juniferTicket: IJuniferTicket) => {
      const defaultStepCodes = [
        preDefaultStepCode,
        preSatisfiedDefaultClosedStepCode,
        defaultStepCode,
        preDefaultClosedStepCode,
        preSatisfiedDefaultStepCode,
      ]
      return (
        defaultStepCodes.includes(juniferTicket.stepCode) &&
        juniferTicket.isOpen
      )
    },
  )

  const latestDefaultNotice = [...defaultNoticeTickets].sort((a, b) =>
    a.createdDate.isAfter(b.createdDate) ? -1 : 1,
  )[0]

  return latestDefaultNotice
}
